import { roles } from '@nxsys/store/constants';
import EarningStatementListing from '../../../modules/earning-statement/listing/EarningStatementListing';

export const earningStatementConfig = [
  {
    permittedRole: [roles.employee],
    path: '/earning-statement',
    element: <EarningStatementListing />,
  },
];
